export const DESKTOP_APP_BASE_PATH = '/app';

const STATIC_PATH_PREFIXES = ['/api/', '/assets/', '/logos/', '/visualbench/', '/og/'];
const STATIC_PATHS = new Set([
  '/favicon.ico',
  '/favicon-16x16.png',
  '/favicon-32x32.png',
  '/favicon-48x48.png',
  '/apple-touch-icon.png',
  '/site.webmanifest',
  '/robots.txt',
  '/sitemap.xml',
  '/og.png',
  '/og.webp',
  '/cli.sh',
]);

function pathnameOnly(pathname: string): string {
  const rawPath = (pathname || '/').split(/[?#]/)[0] || '/';
  return rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
}

export function isDesktopAppPath(pathname: string): boolean {
  const path = pathnameOnly(pathname);
  return path === DESKTOP_APP_BASE_PATH || path.startsWith(`${DESKTOP_APP_BASE_PATH}/`);
}

export function stripDesktopAppBasePath(pathname: string): string {
  const path = pathnameOnly(pathname);
  if (path === DESKTOP_APP_BASE_PATH) return '/';
  if (path.startsWith(`${DESKTOP_APP_BASE_PATH}/`)) return path.slice(DESKTOP_APP_BASE_PATH.length) || '/';
  return path;
}

export function isClientRoutePath(pathname: string): boolean {
  const path = pathnameOnly(pathname);
  if (STATIC_PATHS.has(path)) return false;
  return !STATIC_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function desktopAppPathForNavigation(pathname: string, currentPathname: string): string {
  const path = pathnameOnly(pathname);
  if (!isDesktopAppPath(currentPathname) || isDesktopAppPath(path) || !isClientRoutePath(path)) return path;
  return path === '/' ? `${DESKTOP_APP_BASE_PATH}/` : `${DESKTOP_APP_BASE_PATH}${path}`;
}
